import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import Approvelist from "./ApproveList";
import Approvedata from "./ApproveData";

function ApproveTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="approvelist"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="approvelist" title="อนุมัติการจดทะเบียนชาวไร่อ้อย">
          <Approvelist />
        </Tab>
        <Tab eventKey="approvedata" title="ข้อมูลการจดทะเบียนชาวไร่อ้อย">
          <Approvedata />
        </Tab>
      </Tabs>
    </>
  );
}

export default ApproveTab;
